/**
 * Origem Flow: serviço do Gmail dentro da tarefa.
 */
export default (client) => {
  return {
    status() {
      return client.get('/gmail/status/')
    },
    authUrl(returnPath) {
      const params = new URLSearchParams({ return_path: returnPath })
      return client.get(`/gmail/auth-url/?${params.toString()}`)
    },
    disconnect() {
      return client.post('/gmail/disconnect/')
    },
    send(to, subject, body) {
      return client.post('/gmail/send/', { to, subject, body })
    },
    search(query) {
      const params = new URLSearchParams({ q: query })
      return client.get(`/gmail/search/?${params.toString()}`)
    },
    links(tableId, rowId) {
      return client.get(`/gmail/links/${tableId}/${rowId}/`)
    },
    createLink(tableId, rowId, thread) {
      return client.post(`/gmail/links/${tableId}/${rowId}/`, {
        thread_id: thread.thread_id,
        subject: thread.subject,
        last_from: thread.last_from,
      })
    },
    linkDetail(linkId) {
      return client.get(`/gmail/link/${linkId}/`)
    },
    deleteLink(linkId) {
      return client.delete(`/gmail/link/${linkId}/`)
    },
  }
}
